import { List } from 'immutable'
import * as pages from '../pages'

const routesMap = {
  privacyPolicyPage: {
    pattern: '/privacy-policy',
    component: pages.PrivacyPolicyPage,
    exactly: true,
  },
  tutorialPage: {
    pattern: '/tutorial',
    component: pages.TutorialPage,
    exactly: true,
  },
  languagesGrammarPage: {
    pattern: '/grammar',
    component: pages.LanguagesGrammarPage,
    exactly: true,
  },
  languageGrammarRulesListPage: {
    pattern: '/grammar/:id',
    component: pages.LanguageGrammarRulesListPage,
    exactly: true,
  },
  languageGrammarRuleDetailPage: {
    pattern: '/grammar/:id/:rule',
    component: pages.LanguageGrammarRuleDetailPage,
    exactly: true,
  },
  videosPage: {
    pattern: '/videos',
    component: pages.VideosPage,
    exactly: true,
  },
  videosProfilePage: {
    pattern: '/videos/:subject/:id',
    component: pages.VideosProfilePage,
    exactly: true,
  },
  studentLanding: {
    pattern: '/student-landing',
    component: pages.StudentLandingPage,
    exactly: true,
  },
  testStudent: {
    pattern: '/test/:id',
    component: pages.TestPage,
    exactly: true,
  },
  homeworkFill: {
    pattern: '/homework/:id',
    component: pages.TestPage,
    exactly: true,
  },
  sampleTest: {
    pattern: '/sample-test/:id',
    component: pages.TestPage,
    exactly: true,
  },
  signin: {
    pattern: '/sign-in',
    component: pages.SignInPage,
    exactly: true,
  },
  onboarding: {
    pattern: '/onboarding',
    component: pages.OnboardingPage,
    exactly: true,
  },
  learnFirstList: {
    pattern: '/onboarding-learn',
    component: pages.FirstListLearnPage,
    exactly: true,
  },
  signup: {
    pattern: '/sign-up',
    component: pages.SetLanguagesPage,
    exactly: true,
  },
  signupForm: {
    pattern: '/sign-up-form',
    component: pages.SignUpPage,
    exactly: true,
  },
  signout: {
    pattern: '/sign-out',
    component: pages.SignOutPage,
    exactly: true,
  },
  forgottenPassword: {
    pattern: '/forgotten-password',
    component: pages.ForgottenPasswordPage,
    exactly: true,
  },
  notFound: {
    pattern: '/404',
    component: pages.NotFoundPage,
  },
  pexeso: {
    pattern: '/memory-game/:id',
    component: pages.PexesoPage,
  },
  crossword: {
    pattern: '/crossword/:id',
    component: pages.CrosswordPage,
  },
  subscribe: {
    pattern: '/subscribe',
    component: pages.SubscribePage,
  },
  vocabularyLearn: {
    pattern: '/vocabulary-learn/:id',
    component: pages.VocabularyLearnPage,
  },
  vocabularyLearnStep: {
    pattern: '/vocabulary-learn/:id/:step',
    component: pages.VocabularyLearnPage,
    // exactly: true,
  },
  lessonDetail: {
    pattern: '/lessons/:id',
    component: pages.LessonDetailPage,
    exactly: true,
  },
  lessonInstagram: {
    pattern: '/instagram/:id',
    component: pages.LessonInstagramPage,
    exactly: true,
  },
  firstList: {
    pattern: '/first-list',
    component: pages.FirstListPage,
    exactly: true,
  },
  firstTest: {
    pattern: '/first-test',
    component: pages.FirstTestPage,
    exactly: true,
  },
  privateArea: {
    pattern: '/app',
    component: pages.AuthorizedPage,
    routes: {
      root: {
        pattern: '/app',
        component: pages.LessonsPage,
        exactly: true,
      },
      welcome: {
        pattern: '/app/welcome',
        component: pages.WelcomePage,
        exactly: true,
      },
      admin: {
        pattern: '/app/admin',
        component: pages.AdminPage,
        exactly: true,
      },
      localization: {
        pattern: '/app/localization',
        component: pages.LocalizationPage,
        exactly: true,
      },
      lessons: {
        pattern: '/app/lessons',
        component: pages.LessonsPage,
        exactly: true,
      },
      createGroup: {
        pattern: '/app/create-group',
        component: pages.GroupFormPage,
        exactly: true,
      },
      createLesson: {
        pattern: '/app/create-lesson',
        component: pages.CreateLessonPage,
        exactly: true,
      },
      createOptions: {
        pattern: '/app/create-options',
        component: pages.OptionsFormPage,
        exactly: true,
      },
      editOptions: {
        pattern: '/app/edit-options/:id',
        component: pages.OptionsFormPage,
        exactly: true,
      },
      createWordbox: {
        pattern: '/app/create-wordbox',
        component: pages.WordboxFormPage,
        exactly: true,
      },
      editWordbox: {
        pattern: '/app/edit-wordbox/:id',
        component: pages.WordboxFormPage,
        exactly: true,
      },
      createTranslation: {
        pattern: '/app/create-translation',
        component: pages.TranslationFormPage,
        exactly: true,
      },
      editTranslation: {
        pattern: '/app/edit-translation/:id',
        component: pages.TranslationFormPage,
        exactly: true,
      },
      createOpenQuestion: {
        pattern: '/app/create-open-question',
        component: pages.OpenQuestionFormPage,
        exactly: true,
      },
      editOpenQuestion: {
        pattern: '/app/edit-open-question/:id',
        component: pages.OpenQuestionFormPage,
        exactly: true,
      },
      searchLessons: {
        pattern: '/app/search',
        component: pages.SearchPage,
        exactly: true,
      },
      testDetail: {
        pattern: '/app/test/:id',
        component: pages.TestDetailPage,
        exactly: true,
      },
      createTest: {
        pattern: '/app/create-test/:id?',
        component: pages.TestFormPage,
        exactly: true,
      },
      editGroup: {
        pattern: '/app/edit-group/:id',
        component: pages.GroupFormPage,
        exactly: true,
      },
      editTest: {
        pattern: '/app/edit-test/:id',
        component: pages.TestFormPage,
        exactly: true,
      },
      groups: {
        pattern: '/app/groups',
        component: pages.GroupsPage,
        exactly: true,
      },
      groupPage: {
        pattern: '/app/groups/:id',
        component: pages.GroupDetailPage,
        exactly: true,
      },
      tests: {
        pattern: '/app/tests',
        component: pages.TestsPage,
        exactly: true,
      },
      practice: {
        pattern: '/app/practice/:id',
        component: pages.TestPage,
        exactly: true,
      },
      result: {
        pattern: '/app/result/:id',
        component: pages.ResultPage,
        exactly: true,
      },
      myResults: {
        pattern: '/app/my-results',
        component: pages.StudentResultsPage,
        exactly: true,
      },
      results: {
        pattern: '/app/results/:id',
        component: pages.ResultsPage,
        exactly: true,
      },
      profile: {
        pattern: '/app/user',
        component: pages.UserPage,
        exactly: true,
      },
      studentPage: {
        pattern: '/app/student/:id',
        component: pages.StudentPage,
        exactly: true,
      },
      user: {
        pattern: '/app/user/:id',
        component: pages.UserPage,
        exactly: true,
      },
      followers: {
        pattern: '/app/followers',
        component: pages.FollowersPage,
      },
      following: {
        pattern: '/app/following/:id',
        component: pages.FollowingPage,
      },
      setLanguages: {
        pattern: '/app/set-languages',
        component: pages.SetLanguagesPage,
        exactly: true,
      },
      changePass: {
        pattern: '/app/change-password',
        component: pages.ChangePasswordPage,
        exactly: true,
      },
      /* homeworks */
      homeworks: {
        pattern: '/app/homeworks',
        component: pages.HomeworksPage,
        exactly: true,
      },
      homework: {
        pattern: '/app/homework/:id',
        component: pages.HomeworkDetailPage,
        exactly: true,
      },
      createHomework: {
        pattern: '/app/create-homework',
        component: pages.HomeworkFormPage,
        exactly: true,
      },
      editHomework: {
        pattern: '/app/edit-homework/:id',
        component: pages.HomeworkFormPage,
        exactly: true,
      },
    },
  },
  staticPage: {
    pattern: '/',
    component: pages.StaticPage,
    exactly: true,
  },
}

const routes = Object.keys(routesMap).map(key => routesMap[key])
export const links = routesMap

export const flattenRoutes = (routes, components = new List()) => {
  const flattened = Object.keys(routes).reduce((flatRoutes, key) => {
    const route = routes[key]
    const routeComponents = components.push(route.component)
    flatRoutes = flatRoutes.concat([{
      pattern: route.pattern,
      components: routeComponents.toJS(),
      exact: route.exactly || false,
      strict: route.strict || false,
    }])
    if (route.routes) flatRoutes = flatRoutes.concat(flattenRoutes(route.routes, routeComponents))
    return flatRoutes
  }, [])
  return flattened
}

export default routes



// WEBPACK FOOTER //
// ./src/browser/app/routes.js